import "./App.css";
import Dashboard from "./Dashboard/Dashboard/Dashboard";

function App() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default App;
